import { useParams } from 'react-router-dom'
import PostLayout from '../../components/blog/PostLayout'
import NotFound from '../NotFound'
import { getPostBySlug } from '../../lib/blog/posts'

export default function BlogPostPage() {
  const { slug = '' } = useParams()
  const post = getPostBySlug(slug)
  if (!post) return <NotFound />
  return <PostLayout post={post} />
}
